import React, { Component } from "react";

import styled from "styled-components";
import ConfettiCannon from "common/helpers/confettiCannon";

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
`;

const Copy = styled.div`
  position: absolute;
  top: 45%;
  left: 0;
  width: 100%;
  text-align: center;
  pointer-events: none;
  font-family: "Futura", "Helvetica Neue", Helvetica;
  color: #333;
`;

class Confetti extends Component {
  constructor(props) {
    super(props);

    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    this.confettiCannon = new ConfettiCannon(this.canvasRef.current);
  }

  boom(amount, angle, velocity, x0, y0) {
    this.confettiCannon.addConfettiParticles(amount, angle, velocity, x0, y0);
  }

  doubleCannon() {
    // this.boom(150,270+45,3500,0,this.confettiCannon.canvas.height)
    // this.boom(150,270-45,3500,this.confettiCannon.canvas.width,this.confettiCannon.canvas.height)
    this.boom(300, 270 + 45, 7500, 0, this.confettiCannon.canvas.height);
    this.boom(
      300,
      270 - 45,
      7500,
      this.confettiCannon.canvas.width,
      this.confettiCannon.canvas.height
    );
  }

  render() {
    return (
      <Container>
        <canvas ref={this.canvasRef} />
      </Container>
    );
  }
}

export default Confetti;
